import styled from 'styled-components'

export const CallActionsPostModal = styled.div`
  gap: 0.5rem;
`

CallActionsPostModal.displayName = 'CallActionsPostModal'

export const CustomButton = styled.button`
  &:not(.disabled):hover {
    background-color: var(--gray-100) !important;
  }

  &:focus,
  &:active {
    outline: none;
  }

  &.disabled {
    cursor: not-allowed;
  }
`

CustomButton.displayName = 'CustomButtonPostModalActions'
